import { ReactNode } from "react";
import { Card, CardContent } from "../../../../../components/ui/card";

interface BaixaStatCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  className?: string;
}

export function BaixaStatCard({
  title,
  value,
  icon,
  className,
}: BaixaStatCardProps) {
  return (
    <Card className={className}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-lg font-bold mt-2">{value}</p>
          </div>
          {icon && <div className="ml-4 text-primary opacity-80">{icon}</div>}
        </div>
      </CardContent>
    </Card>
  );
}
